import { useLayoutEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import useContainerBreakpoint from '@elementary/common-ui/hooks/useContainerBreakpoint';
import * as atoms from '@elementary/common-ui/atoms';

const RESPONSIVE_BREAKPOINTS = [
  { key: 'small', width: 1420 },
  { key: 'extraSmall', width: 1000 },
];

const useResponsiveLayout = () => {
  const { ref, breakpoint } = useContainerBreakpoint(RESPONSIVE_BREAKPOINTS);

  const [treeViewCollapsed, setTreeViewCollapsed] = useRecoilState(
    atoms.treeViewCollapsed,
  );
  const [navbarCollapsed, setNavbarCollapsed] = useRecoilState(
    atoms.navbarCollapsed,
  );

  const isTreeViewNeeded = useMemo(
    () => treeViewCollapsed.userOverride !== true,
    [treeViewCollapsed.userOverride],
  );

  const layout = useMemo(() => {
    if (breakpoint === 'extraSmall') {
      return { collapseNavbar: true, collapseTreeView: true };
    }
    if (breakpoint === 'small' && isTreeViewNeeded) {
      return { collapseNavbar: true, collapseTreeView: false };
    }
    return {
      collapseNavbar: navbarCollapsed.userOverride === true,
      collapseTreeView: !isTreeViewNeeded,
    };
  }, [breakpoint, isTreeViewNeeded, navbarCollapsed.userOverride]);

  useLayoutEffect(() => {
    if (navbarCollapsed.isCollapsed !== layout.collapseNavbar) {
      setNavbarCollapsed({
        ...navbarCollapsed,
        isCollapsed: layout.collapseNavbar,
      });
    }
    if (treeViewCollapsed.isCollapsed !== layout.collapseTreeView) {
      setTreeViewCollapsed({
        ...treeViewCollapsed,
        isCollapsed: layout.collapseTreeView,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout.collapseNavbar, layout.collapseTreeView]);

  return { contentRef: ref };
};

export default useResponsiveLayout;
